import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => {
  return {};
});

export default useStyles;
